import { useEffect, useState } from "react";

function getInitialVisibility() {
	if (typeof document === "undefined") {
		return true;
	}
	return document.visibilityState !== "hidden";
}

export function useDocumentVisible() {
	const [visible, setVisible] = useState(getInitialVisibility);

	useEffect(() => {
		const onVisibilityChange = () => {
			setVisible(document.visibilityState !== "hidden");
		};

		document.addEventListener("visibilitychange", onVisibilityChange);
		return () => document.removeEventListener("visibilitychange", onVisibilityChange);
	}, []);

	return visible;
}
